import axios from "axios";

export const createLockerCommandKey = ({
  prefix = "lock",
  storageId,
  reserveId,
  historyId,
  suffix,
}) => {
  const parts = [prefix];

  if (reserveId !== undefined && reserveId !== null) parts.push(`r${reserveId}`);
  if (historyId !== undefined && historyId !== null) parts.push(`h${historyId}`);
  if (storageId !== undefined && storageId !== null) parts.push(`s${storageId}`);
  if (suffix !== undefined && suffix !== null) parts.push(String(suffix));

  return parts.join("-");
};

export const requestOpenLockCommand = async ({
  point = "bank",
  storageId,
  pulseMs = 400,
  requestedBy = "kiosk",
  requestNote = "",
  commandKey,
}) => {

  // 수정
  if (storageId === undefined || storageId === null) {
    throw new Error("storageId가 없습니다.");
  }

  const res = await axios.post("/api/bread-storage/lock-command", {
    point,
    storageId,
    pulseMs,
    requestedBy,
    requestNote,
    commandKey:
      commandKey ||
      createLockerCommandKey({
        prefix: "manual-open",
        storageId,
        suffix: `${Date.now()}-${Math.random()}`
      }),
  });

  return res.data;
};

export const requestOpenLockCommands = async ({
  point = "bank",
  storages = [],
  pulseMs = 400,
  requestedBy = "kiosk",
  requestNote = "",
  keyPrefix = "batch-open",
  reserveId,
}) => {

  if (!Array.isArray(storages) || !storages.length) {
    return [];
  }

  const results = [];

  for (const storage of storages) {
    const storageId = storage?.storageId;
    const historyId = storage?.id;

    // 수정
    if (storageId === undefined || storageId === null) continue;

    const result = await requestOpenLockCommand({
      point,
      storageId,
      pulseMs,
      requestedBy,
      requestNote,
      commandKey: createLockerCommandKey({
        prefix: keyPrefix,
        reserveId,
        historyId,
        storageId,
        suffix: `${Date.now()}-${Math.random()}`
      }),
    });

    results.push(result);
  }

  return results;
};